import React, { useEffect, useState } from "react";
import { Button, Card, CircularProgress, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, TextField } from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import { connect } from "react-redux";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { Required } from "ui-component/custom-components/mandatory";
import { anticoccidalCreate, anticoccidalCreateErrorClear } from "store/app/form-management/anticoccidal-configuration/actions";
import { AllowedSpecialCharacters, AllowedSpecialCharactersPaste } from "helper/regex";

const CreateAnticoccidial = (props) => {

    const { open, filter, paginationData, errorMessage, onClose, isPending } = props;

    const [anticoccidialData, setAnticoccidialData] = useState();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        props.anticoccidalCreateErrorClear();
        setAnticoccidialData();
        setErrors({});
    }, [open])

    const validateOnchange = (e) => {
        const { name, value } = e.target;

        setAnticoccidialData({
            ...anticoccidialData,
            [name]: value
        })
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const handleAnticoccidialCreate = (e) => {
        e.preventDefault();

        const { anticoccidial } = anticoccidialData || {};
        const currentErrors = {};

        if (!anticoccidial && !anticoccidial?.trim()) {
            currentErrors.anticoccidial = 'Anticoccidial is required';
        }
        setErrors(currentErrors);

        if (Object.keys(currentErrors).length === 0) {
            props.anticoccidalCreate(anticoccidialData, filter, paginationData);
        }
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog open={open} maxWidth={'xs'} fullWidth onClose={validateClose}>
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Create Anticoccidial
                                <IconButton aria-label="close" onClick={onClose}>
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                {errorMessage && <ErrorAlert content={errorMessage} />}
                                <form>
                                    <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                        <Grid item >
                                            <TextField
                                                label={<div >Anticoccidial <Required /></div>}
                                                sx={{ mt: 1 }}
                                                fullWidth
                                                autoFocus
                                                autoComplete="off"
                                                size="small"
                                                name='anticoccidial'
                                                type='text'
                                                onChange={validateOnchange}
                                                onKeyDown={AllowedSpecialCharacters}
                                                onPaste={AllowedSpecialCharactersPaste}
                                                error={errors?.anticoccidial}
                                                helperText={errors?.anticoccidial}
                                            />
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                onClick={handleAnticoccidialCreate}
                                                size="small"
                                                color="primary"
                                                disabled={isPending || Object.keys(removeEmptyKeys(errors))?.length > 0}
                                            >
                                                {isPending ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <CircularProgress size={'20px'} color='inherit' />
                                                    Loading...
                                                </div>
                                                    : 'Submit'
                                                }
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={onClose}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                            >
                                                Close
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    isPending: state.anticoccidals.isAnticoccidalCreatePending,
    errorMessage: state.anticoccidals.anticoccidalCreateErrorMessage,
})
const mapDispatchToProps = (dispatch) => ({
    anticoccidalCreate: (formData, filter, paginationData) => dispatch(anticoccidalCreate(formData, filter, paginationData)),
    anticoccidalCreateErrorClear: () => dispatch(anticoccidalCreateErrorClear()),
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateAnticoccidial);